// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__2SQcF","small":"Input_small__18xcg","title":"Input_title__11WR9"};